import React, { useState, useEffect } from "react";
import { 
  Box, Card, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, IconButton, Icon, Dialog, 
  DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, FormControl, InputLabel, Button
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { get, postUpload, getFile } from "utils/WebService";

const TIPOS_DOCUMENTO = [
    { id: 1, label: "Pesquisa Receita Federal" },
    { id: 2, label: "Pesquisa Web" },
    { id: 3, label: "Pesquisa Unitfour" },
    { id: 4, label: "Pesquisa API" },
    { id: 99, label: "Outros" }
];

export default function Dossie({ recordId, isViewOnly }) {
    const [documentos, setDocumentos] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [file, setFile] = useState(null);
    const [tipo, setTipo] = useState(2); // Default to Pesquisa Web
    const [observacao, setObservacao] = useState("");
    const [loading, setLoading] = useState(false);

    const loadDocumentos = () => {
        get(`/dossie/list/${recordId}`)
            .then(res => {
                if (Array.isArray(res)) setDocumentos(res);
            })
            .catch(err => console.error(err));
    };

    useEffect(() => {
        if (recordId) loadDocumentos();
    }, [recordId]);

    const handleUpload = () => {
        if (!file) return;
        setLoading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("tipoDocumentoId", tipo);
        formData.append("observacao", observacao);

        postUpload(`/dossie/upload/${recordId}`, formData)
            .then(res => {
                setOpenModal(false);
                setFile(null);
                setObservacao("");
                loadDocumentos();
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    };

    const handleGenerateDossie = () => {
        getFile(`/dossie/download/${recordId}`)
            .catch(err => {
                alert("Erro ao gerar PDF: " + err.message);
                console.error(err);
            });
    };

    return (
        <MDBox pt={2} pb={3}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDTypography variant="h6">Dossiê de Pesquisa e Localização</MDTypography>
                <Box>
                    <MDButton 
                        variant="contained" 
                        color="info" 
                        startIcon={<Icon>upload_file</Icon>}
                        onClick={() => setOpenModal(true)}
                        sx={{ mr: 2, color: '#fff' }}
                    >
                        Adicionar Evidência
                    </MDButton>
                    <MDButton 
                        variant="contained" 
                        color="success" 
                        startIcon={<Icon>picture_as_pdf</Icon>}
                        onClick={handleGenerateDossie}
                        sx={{ color: '#fff' }}
                    >
                        Gerar Dossiê PDF
                    </MDButton>
                </Box>
            </MDBox>

            <TableContainer component={Card}>
                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell>Data</TableCell>
                            <TableCell>Tipo</TableCell>
                            <TableCell>Arquivo</TableCell>
                            <TableCell>Observação</TableCell>
                            <TableCell>Usuário</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {documentos.map((doc) => (
                            <TableRow key={doc.id}>
                                <TableCell>{new Date(doc.dataUpload).toLocaleDateString()}</TableCell>
                                <TableCell>{doc.tipoDocumentoDescricao}</TableCell>
                                <TableCell>{doc.nomeArquivo}</TableCell>
                                <TableCell>{doc.observacao}</TableCell>
                                <TableCell>{doc.nomeUsuarioCriacao}</TableCell>
                            </TableRow>
                        ))}
                        {documentos.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">Nenhuma evidência anexada</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Adicionar Evidência / Print</DialogTitle>
                <DialogContent>
                    <Box mt={2}>
                        <input 
                            type="file" 
                            onChange={(e) => setFile(e.target.files[0])}
                            accept="image/*,.pdf"
                        />
                    </Box>
                    <Box mt={3}>
                        <FormControl fullWidth>
                            <InputLabel>Tipo de Evidência</InputLabel>
                            <Select
                                value={tipo}
                                onChange={(e) => setTipo(e.target.value)}
                                label="Tipo de Evidência"
                                sx={{ height: 45 }}
                            >
                                {TIPOS_DOCUMENTO.map(t => (
                                    <MenuItem key={t.id} value={t.id}>{t.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box mt={3}>
                        <TextField
                            fullWidth
                            label="Observação (Ex: telefone não atende...)"
                            multiline
                            rows={3}
                            value={observacao}
                            onChange={(e) => setObservacao(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setOpenModal(false)}>Cancelar</MDButton>
                    <MDButton onClick={handleUpload} variant="contained" color="info" disabled={!file || loading} sx={{ color: '#fff' }}>
                        {loading ? 'Salvando...' : 'Salvar'}
                    </MDButton>
                </DialogActions>
            </Dialog>
        </MDBox>
    );
}
